export default "__VITE_ASSET__DOoFDR02__"